import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProCompanyDetails';

const AccountJulaProCompanyDetailsSuspense = dynamic(
	() => import('./AccountJulaProCompanyDetails'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaProCompanyDetails(props: Props) {
	return <AccountJulaProCompanyDetailsSuspense {...props} />;
}
DynamicAccountJulaProCompanyDetails.displayName =
	'DynamicAccountJulaProCompanyDetails';
